import React from 'react'
import Helmet from 'react-helmet'
import urljoin from 'url-join'
import config from '../config'

const Seo = ({ post, title, url, keywords, description, image }) => {
  const siteTitle = config.siteMetadata.title
  const pageTitle = title ? `${title} | ${siteTitle}` : siteTitle
  const pageURL = url
    ? urljoin(config.siteMetadata.siteUrl, url)
    : config.siteMetadata.siteUrl
  const pageKeywords = keywords || config.siteMetadata.keywords
  const pageDesc = description || config.siteMetadata.description
  const pageImage = image
    ? urljoin(config.siteMetadata.siteUrl, image)
    : config.siteMetadata.siteLogo

  return (
    <Helmet title={pageTitle}>
      <html lang='zh' />
      <meta name='keywords' content={pageKeywords} />
      <meta name='description' content={pageDesc} />
      <meta name='image' content={pageImage} />

      {/* TODO -- Schema.org tags */}

      {/* OpenGraph tags */}
      <meta property='og:url' content={pageURL} />
      <meta property='og:title' content={pageTitle} />
      <meta property='og:description' content={pageDesc} />
      <meta property='og:site_name' content={siteTitle} />
      {post
        ? (
          <meta property='og:type' content='article' />
          )
        : (
          <meta property='og:type' content='website' />
          )}

      {/* TODO -- Twitter Card tags */}
      {/* TODO -- Facebook App */}
    </Helmet>
  )
}

export default Seo
